// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1pxOP","title":"FrontImage_title__34eUv"};